/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import ISearchResultsApiClient from './contracts'
import { ISearchResultsList, ISection } from '../SearchResultsStateManager/contracts'
import { injectable } from 'inversify'

@injectable()
export class MockSearchResultsApiClient implements ISearchResultsApiClient {
	searchResutsList: ISearchResultsList
	/**
	 *
	 */
	constructor () {
		this.searchResutsList = {
			total: 2,
			items: [
				{
					productCode: 'CareWatch',
					sectionList: [{ sectionName: 'MDS', sectionId: '4tkzx1a5afbk4x4e5w2p7f58m4' } as ISection],
					articleName: 'Article-2',
					articlePath: '/article-1',
					articleDescription: 'Test MDN',
					articlePublishDate: 'Nov 23,2020',
				},
				{
					productCode: 'UB Watch',
					sectionList: [{ sectionName: 'FAQ', sectionId: '4nwtf7gffv5295g497g0sfe8d1' } as ISection],
					articleName: 'Article-2',
					articlePath: '/article-2',
					articleDescription: 'Test UB Watch',
					articlePublishDate: 'Nov 23,2020',
				},
			],
		} as ISearchResultsList
	}

	getSearchResults(param: string): Promise<ISearchResultsList> {
		const data = this.searchResutsList
		return new Promise<ISearchResultsList>(resolve => {
			resolve(data)
		})
	}
}
